export const MAX_FILE_SIZE_BYTES = 50 * 1024 * 1024;
export const MAX_ARCHIVE_SIZE_BYTES = 200 * 1024 * 1024;

export const UPLOAD_PROGRESS_MIN_DURATION_MS = 500;
export const UPLOAD_CONCURRENCY = 4;

export const WS_REASON_CONFLICT_EXPIRED = 'Unknown or expired conflict';
export const WS_FALLBACK_ERROR_REASON = 'tenders.responses.documents.ignored-reason-upload-error';

export const WS_ERROR_REASON_MAP: Record<string, string> = {
  'Document too large': 'tenders.responses.documents.ignored-reason-too-large',
  'Unsupported file type in archive': 'tenders.responses.documents.ignored-reason-unsupported-file-type',
  'Replace failed': 'tenders.responses.documents.ignored-reason-replace-failed',
  'S3 upload failed': 'tenders.responses.documents.ignored-reason-upload-error',
  'Invalid conflict resolution message': 'tenders.responses.documents.ignored-reason-upload-error',
  'Document already exists': 'tenders.responses.documents.ignored-reason-already-exists',
};
